/* Galerie de la fiche (passe visuelle du 08/10) : flèches, compteur et barres du carrousel ; clavier gauche/droite. */
document.querySelectorAll('[data-v2-gal]').forEach(g => {
  const track = g.querySelector('.v2-gal__track'), items = track ? track.children : [];
  if (!track || items.length < 2) return;
  const prev = g.querySelector('[data-v2-gal-prev]'), next = g.querySelector('[data-v2-gal-next]'),
        n = g.querySelector('[data-v2-gal-n]'), dots = g.querySelectorAll('.v2-gal__dots i');
  const cur = () => Math.round(track.scrollLeft / track.clientWidth);
  const go = i => track.scrollTo({left: Math.max(0, Math.min(items.length - 1, i)) * track.clientWidth});
  const sync = () => {
    const i = cur();
    if (n) n.textContent = i + 1;
    dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= items.length - 1;
  };
  prev && prev.addEventListener('click', () => go(cur() - 1));
  next && next.addEventListener('click', () => go(cur() + 1));
  track.addEventListener('scroll', sync, {passive: true});
  g.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') go(cur() - 1); if (e.key === 'ArrowRight') go(cur() + 1); });
  addEventListener('resize', () => go(cur()));
  sync();
});

/* Ordinateur : diaporama pot → tableau dans la grande carte. Deux vignettes cliquables ; la ligne sous la vignette active
   avance pendant 5 s puis la carte passe à l'autre vue. Pause au survol de la carte. Pas de lecture auto si mouvement réduit. */
document.querySelectorAll('[data-v2-gal]').forEach(g => {
  const ui = g.querySelector('[data-v2-hero]'), items = g.querySelectorAll('.v2-gal__item');
  if (!ui || items.length < 2) return;
  const mq = matchMedia('(min-width:1001px)'), slides = [items[0], items[1]], N = slides.length, DUR = 5000,
        still = matchMedia('(prefers-reduced-motion: reduce)').matches, th = ui.querySelectorAll('[data-v2-hero-go]');
  let i = 0, t = 0, last = 0, hover = false, raf = 0;
  const show = k => {
    i = (k + N) % N; t = 0;
    slides.forEach((s, j) => s.classList.toggle('is-hero', j === i));
    th.forEach((b, j) => { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', String(j === i)); b.style.setProperty('--p', 0); });
  };
  const tick = now => {
    if (!hover && !still && last) { t += now - last; if (t >= DUR) show(i + 1); }
    last = now; th[i].style.setProperty('--p', (t / DUR).toFixed(4)); raf = requestAnimationFrame(tick);
  };
  const on = () => {
    cancelAnimationFrame(raf);
    if (!mq.matches) { g.classList.remove('has-hero'); slides.forEach(s => s.classList.remove('is-hero')); return; }
    g.classList.add('has-hero'); show(i); last = 0; raf = requestAnimationFrame(tick);
  };
  th.forEach(b => b.addEventListener('click', () => show(+b.dataset.v2HeroGo)));
  [...slides, ui].forEach(el => { el.addEventListener('mouseenter', () => { hover = true; }); el.addEventListener('mouseleave', () => { hover = false; last = 0; }); });
  document.addEventListener('visibilitychange', () => { last = 0; });
  mq.addEventListener('change', on);
  on();
});

/* Ordinateur : hauteur de la galerie = fenêtre sous l'en-tête, mesurée à l'arrivée (haut de la fiche + 20 px de marge haute + 20 px de marge basse ; mesuré sur la fiche, pas sur la galerie fixe) */
document.querySelectorAll('[data-v2-gal]').forEach(g => {
  const set = () => g.style.setProperty('--v2-gal-top', Math.round(g.parentElement.getBoundingClientRect().top + scrollY + 40) + 'px');
  set(); addEventListener('resize', set);
});
